@if (!isLoaded) {
<busy-indicator [big]="true"></busy-indicator>
}
@else {
@if (!hasEmails) {
<div>No Emails to Send</div>
}
@else {
<div [formGroup]="formGroup" fxLayout="column" fxLayoutAlign="stretch start">
    <h3>Send PO Notice Emails</h3>
    <lgd-text fxFlexFill controlName="subject" label="Email Subject">
    </lgd-text>
    <lgd-textarea fxFlexFill controlName="message" label="Email Message">
    </lgd-textarea>
    <div fxFlexFill class="mt20 bold">Email Recipients</div>

    <div fxFlexFill class="mt5 scrollable-pane">
        <mat-list fxFlex>
            @for (req of emails; track req; let isEven = $even; let isLast = $last) {
            @if (req.Emails.length > 0) {
            <mat-list-item fxLayout="row" fxLayoutAlign="start center" [ngClass]="getEmailGroupClass(isEven)">
                <div class="mt10">
                    <span class="bold">{{ req.Number }} - {{ req.Description }}</span>
                    <ul>
                        @for (email of req.Emails; track email) {
                        <li>
                            @if (email.IsVendorEmail) {
                            <span fxFlex="50">{{ req.Vendor }}: </span>
                            }
                            @else {
                            <span fxFlex="50">Not a Vendor: </span>
                            }
                            <span fxFlex="50" class="bold">{{ email.EmailAddress }}</span>
                        </li>
                        }
                    </ul>
                    @if (!isLast) {
                    <mat-divider></mat-divider>
                    }
                </div>
            </mat-list-item>
            }
            }
        </mat-list>
    </div>
    <lgd-checkbox fxFlex="10" controlName="sendEmails" label="Send Emails">
    </lgd-checkbox>
</div>
}
}